import FormFieldViewText from "components/FormFields/ViewText";
import useTypedContext from "hooks/useTypedContext";

import { ScanSettingsContextData } from "../Context";

const ScanSettingsWorkerPoolView = () => {
  const { scanSettings } = useTypedContext(ScanSettingsContextData);

  return <FormFieldViewText label="Worker pool" value={scanSettings.workerPoolName} noMargin />;
};

export default ScanSettingsWorkerPoolView;
